import React, { useState, useCallback, useMemo } from 'react';
import { svgSprite } from '../../../../../../hybrid/wrappers';
import SearchWindow from '../../../../../searchWindow/SearchWindow';
import { useWindowDimensions } from '../../../../../../common/utils/windowDimensions';
import css from './ModalSeachType.module.scss';
import classnames from 'classnames';

const ModalSeachType = ({ changeHandler, search = {} }) => {
    const { icon, title, url, attrToInput, fastSearch } = search;
    const [hover, setHover] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const afterOpenSwitherClick = () => {
        setShowModal(false);
        return true;
    };
    const getUserData = useCallback(
        async (value) => {
            let val = typeof value === 'object' ? value[attrToInput] : value;
            changeHandler(String(val));
        },
        [changeHandler]
    );
    const widthDimensions = useWindowDimensions();
    const screenWidth = useMemo(() => widthDimensions < 992, [widthDimensions]);
    return (
        <>
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    setShowModal(true);
                }}
                className={css.formControlIconWrap}
            >
                {svgSprite(icon, {
                    className: hover ? classnames(css.formControlLoginSvg, css.formControlLoginSvgHover) : css.formControlLoginSvg
                })}
            </div>
            {showModal && (
                <SearchWindow
                    sendData={{ url }}
                    portalClass={!screenWidth ? 'modalTop' : 'modalBottom'}
                    closeModal={setShowModal}
                    title={title}
                    gridHandlers={{
                        tr: {
                            onClick: (rowData) => {
                                console.log(rowData);
                                if (rowData[attrToInput]) {
                                    getUserData(rowData[attrToInput]);
                                    afterOpenSwitherClick(rowData, 'new');
                                }
                            }
                        }
                    }}
                    customData={{ buttonNotShow: true }}
                    gridConfig={{
                        stickyCell: { 'background-color': 'transparent' },
                        gridConfigCss: {
                            td: {
                                styles: css.usersGridTd,
                                div: css.usersGridSell
                            },
                            0: { td: { div: css.usersGridSellFirst } },
                            2: { td: { div: css.usersGridSellLast } }
                        }
                    }}
                    customStyle={{
                        ...css,
                        searchWindowWrapper: !screenWidth ? { width: '1000px', maxWidth: '1000px' } : {}
                    }}
                    fastSearch={fastSearch}
                />
            )}
        </>
    );
};
export default ModalSeachType;
